export default "__VITE_ASSET__bda4725f__"